import { ORBITA_URL } from 'settings';

export const ORBITA_EDIT_PRODUCT_PATH_URL = `${ORBITA_URL}/producer/product/editproduct/`;
